import * as AuctionStatus from '../constants/AuctionStatus'
import { getTimeRemaining } from './datetime'

export const getAuctionStatusFromTokenMetadata = tokenMetadata => {
  const isDisabled = tokenMetadata?.isBiddingDisabled

  if (isDisabled) {
    return AuctionStatus.BIDDING_DISABLED
  }

  const deadline = tokenMetadata?.deadline

  if (!deadline) {
    return AuctionStatus.FRESH
  }

  const isClaimed = tokenMetadata?.isClaimed

  if (isClaimed) {
    return AuctionStatus.SOLD
  }

  const timeRemaining = getTimeRemaining(deadline)

  // getTimeRemaining returns false if it's in the past
  if (!timeRemaining) {
    return AuctionStatus.WAITING_TO_BE_CLAIMED
  }

  return AuctionStatus.BIDDING
}
